import React from 'react'
import { useSelector } from 'react-redux'

const CalculationOverview = () => {
  const { calculations, loading } = useSelector((state) => state.quickCalculation)

  return (
    <div className='content-inner-data-aside'>
      <div className='content-card-row-title'>
        <h3>Результат расчёта{loading ? '...' : ''}</h3>
      </div>
      <div className='content-card-row'>
        <dl className='dl-horizontal dl-big'>
          <dt>Оценочная стоимость, руб.</dt>
          <dd>{ calculations.totalEstimatedValue !== 0 ? calculations.totalEstimatedValue.toFixed(2) : 0 }</dd>
        </dl>
        <dl className='dl-horizontal dl-big'>
          <dt>Общая сумма к выплате, руб.</dt>
          <dd>{ calculations.amount !== 0 ? calculations.amount.toFixed(2) : 0 }</dd>
        </dl>
        <dl className='dl-horizontal dl-big'>
          <dt>Срок, дней</dt>
          <dd>{ calculations.days }</dd>
        </dl>
      </div>
    </div>
  )
}

export default CalculationOverview
